import { createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { ReservationContractSignatureStatus, ReservationExtent } from '@mews-commander/data-access';

export const SIGNATURE_STATUS_OPTIONS = [
    createOption({
        value: ReservationContractSignatureStatus.Signed,
        label: lt('ContractSignatureStatusSignedLabel'),
    }),
    createOption({
        value: ReservationContractSignatureStatus.Pending,
        label: lt('ContractSignatureStatusPendingLabel'),
    }),
    createOption({
        value: ReservationContractSignatureStatus.NotSigned,
        label: lt('ContractSignatureStatusNotSignedLabel'),
    }),
];

export const DOCUMENTS_RESERVATION_EXTENT = {
    accounts: true,
    orderItems: false,
    products: false,
    reservationGroups: false,
    availabilityBlocks: false,
    companionships: false,
    businessSegments: false,
    generalNotes: false,
    channelManagerNotes: false,
    specialRequestNotes: false,
    vouchers: false,
    partnerCompanies: false,
    rates: false,
    travelAgencies: false,
    origin: false,
    bookingEngines: false,
    purchaseOrderNumbers: false,
} satisfies ReservationExtent;
